import React from "react";
import Test from "./test";

const info = {
  difficulty: "medium",
  title: "Valid Palindrome",
  url: "valid-palindrome",
  problemNumber: 1,
  problem: React.lazy(() => import(`./problem`)),
  test: Test,
  starter: `/**
* @param {String} str
* @return {Boolean}
*/
    
/**
* Do not change this function body
* Do your changes within the function 
*/

return function validPalindrome(str) {
  // your code goes here        
};
`,
};

export default info;
